function sideBar() {
  function link(scope, element, attrs) {
    $(element).ready(function(){
      $('#sidebar_button').click(function(e){
            e.preventDefault();
            if($(window).width() <= 767){
        var height = document.getElementById('right_side').clientHeight;
        $('#sidebar_menu').css("height", height + "px");
      }
            $('#sidebar_menu').show();
            $(this).hide();
        })
        $(document).mouseup(function (e){
            if($(window).width() <= 767){
              $('#sidebar_menu').hide();
              $('#sidebar_button').show();

            }
        });

        // TOUCH DEVICE
        $(document).bind( "touchend", function(e){
            if($(window).width() <= 767){
              $('#siderbar_menu').hide();
              $('#sidebar_button').show();
            }
        });

        //show dropdown menu
        $("nav").find(".tools").on("click", "a", function () {
          $('.navbar-collapse.in').collapse('show');
        });

        //collapse responsive menu on click
        $("nav").find(".header-li").on("click", "a", function () {
        $('.navbar-collapse.in').collapse('hide');
       });
    });
  }
return {
    link: link
  };
}

export default {
  name: 'sideBar',
  fn: sideBar
};

